import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UserResource from 'models/users/resource';
import React, { useContext } from 'react';
import * as Contexts from './Context';

type Props = {
  value: UserResource
};

export const UserRow = ({ value }: Props) => {
  const { selection, setSelection } = useContext(Contexts.SelectionContext);

  return (
    <tr>
      <td>{value.email}</td>
      <td>
        <button
          type="button"
          className="blank-button"
          onClick={() => setSelection({ ...selection, deleting: value })}
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </td>

    </tr>
  );
};
export default UserRow;
